import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, inject } from '@angular/core';
import { AdvancedSearchEmployeesConfigurations, AssignmentGridsConfigurations, PreferencesConfigurationssModel, PROFILE_SOURCES, profileModificationModel, UPEnums, UPGeneralFields, UPSalesFields } from '../../model/user-profile.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Grid, GridConfig, GridRowsSelectedEvent } from '@inavista/components/grid';
import { LOCAL_ROWS_URL, LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { Applications, ISignal, RolePermissionsModel } from '../../../../shared/models/app.model';
import { catchError, finalize, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../../../shared/services/common.service';
import { UserProfileService } from '../../services/user-profile.service';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { Fields, SelectEventArgs } from '@syncfusion/ej2-angular-lists';
import { UserRoles } from 'projects/sales/src/app/shared/constants/app.constants';

const SALES_CHANNELS_URL = `${LOCAL_ROWS_URL}user-profile/sales-channels`;

@Component({
    selector: 'app-up-rims-sales',
    templateUrl: './up-rims-sales.component.html',
    styleUrls: ['./up-rims-sales.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    // The Channels grid's rows are the section's own (LocalRowsGridApi); the assignment grids provide their own, and the
    // employee search popup reaches the server.
    providers: [...provideLocalGridRows()],
    standalone: false
})
export class UpRimsSalesComponent implements OnInit, OnChanges, OnDestroy {

  userId: string = '';
  @Input('source') source: PROFILE_SOURCES = UPEnums.SourceUser;
  @Input('reloadSection') reloadSection: boolean = false;
  salesPreferencesConfig!: PreferencesConfigurationssModel;
  UserProfileService: typeof UserProfileService = UserProfileService;
  UPSalesFields: typeof UPSalesFields = UPSalesFields;
  UPEnums: typeof UPEnums = UPEnums;
  todayDate: Date = new Date(Date.now());
  isFormSubmitted: any;
  salesForm: FormGroup<any>;
  @Output() sendProfileDataToParent = new EventEmitter<any>();

  regionAssignmentConfigs: AssignmentGridsConfigurations;
  districtAssignmentConfigs: AssignmentGridsConfigurations;
  territoryAssignmentConfigs: AssignmentGridsConfigurations;
  employeeIdsData: any[] = [];
  channelsDDLData: any[] = [];
  permissionListFields: Fields = {
    id: 'id',
    text: 'text',
    isChecked: 'isChecked',
    tooltipText: 'tooltipText',
    enabled: 'enabled'
  };
  permissionListItems: { id: string; text: string; tooltipText: string; isChecked: boolean; enabled: boolean }[] = [];
  // Channels: a ticked list of the section's own rows (LocalRowsGridApi), saved with the profile, as before.
  readonly channelsGridConfig: GridConfig = {
    apiBaseUrl: SALES_CHANNELS_URL,
    keyColumn: 'id',
    clientSide: true,
    rowHeight: 26,
    stretchColumns: true,
    enableSearch: false,
    enableFiltering: false,
    enableToolbar: false,
    selectable: true,
    rowCheckLockedFn: () => (!this.isSectionEnabled ? 'This section is disabled'
      : !this.getPermission('Sales_channels')?.enable || !!this.getPermission('Sales_channels')?.readOnly ? 'Your role cannot change the channels' : false),
    defaultColumnOrder: ['text'],
    hiddenByDefaultColumns: ['id', 'value'],
    columnLabels: { text: 'Channels' },
    columnAlign: { text: { header: { horizontal: 'left' } } },
    emptyStateMessage: 'No channels to choose from.',
    persistenceKey: 'rims.users.sales-channels',
    persistenceVersion: 1,
  };
  channelsGrid?: Grid;
  // The grid shows once the permissions are in (@if): tick its rows then.
  @ViewChild('channelsGrid') set channelsGridRef(grid: Grid | undefined) {
    const appeared = !!grid && grid !== this.channelsGrid;
    this.channelsGrid = grid;
    if (appeared) queueMicrotask(() => grid!.setCheckedKeys(this.channelsDDLData.filter(c => c.isChecked).map(c => c.id), { emit: false }));
  }
  private readonly channelRows = inject(LocalRowsGridApi);
  initiallyHasNoEmployeeId: boolean; // ars missing
  newAddress: any;
  markedForPersistenceClearance: boolean;
  warehouseDDL: any[] = [];
  initialRole: any;
  markAddressToBeCopiedOverToGeneral: boolean;
  isRoleChanged: boolean = false;
  isSalesProfileSaveInProgress: boolean = false;
  REGIONS_DATA: any[] = [];
  DISTRICTS_DATA: any[] = [];
  TERRITORY_DATA: any[] = [];
  isCreatingNewUser: boolean = false;
  isSectionEnabled: boolean = false;
  @ViewChild('salesEnableCb') public salesEnableCb!: CheckBoxComponent;
  labelForApproved: HTMLLabelElement;
  employeeId: string = '';
  advancedSearchEmployeesConfigurations: AdvancedSearchEmployeesConfigurations;
  dataFieldsWithEmployeeId = [
    // UPSalesFields.employeeId,
    UPSalesFields.email,
    UPSalesFields.mobile,
    UPSalesFields.name,
    UPSalesFields.address,
    UPSalesFields.city,
    UPSalesFields.state,
    UPSalesFields.country,
    UPSalesFields.zipCode,
  ]
  constructor(private fb: FormBuilder, private usersService: UserProfileService, private commonService: CommonService,
      private cdRef: ChangeDetectorRef) {
    this.userProfile = { userId: '' };
    this.modifiedUI[UPEnums.SalesFormData] = false;
    this.modifiedUI[UPEnums.SalesAssignmentsData] = false;
    this.modifiedUI[UPEnums.SalesPreferencesData] = false;
    this.action = new Subject();
    this.actions = new Subject();
    this.destroy$ = new Subject();
    this.advancedSearchEmployeesConfigurations = {
      popupTitle: "Advanced Employees Search",
      fetchIdsFor: 'sales-employeeIds' 
    };
    let columns: any[] = [
      { field: 'isChecked', type: 'checkbox', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 20, visible: true },
    ];
    this.salesForm = this.fb.group({});



    // Regions
    this.regionAssignmentConfigs = {
      gridId: 'regions-grid0',
      countId: 'regionsCount',
      selectedId: 'regionsSelected',
      gridName: 'Region',
      updatedDataSource: [],
      columns: [...columns,
      { field: 'title', headerText: 'Regions', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 60, visible: true },
      { field: 'countryName', headerText: 'Country', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 60, visible: true }
      ]
    };


    // Districts
    this.districtAssignmentConfigs = {
      gridId: 'districts-grid1',
      countId: 'districtsCount',
      selectedId: 'districtsSelected',
      gridName: 'District',
      updatedDataSource: [],
      columns: [...columns,
      { field: 'title', headerText: 'District', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 60, visible: true },
      { field: 'regionName', headerText: 'Region', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 60, visible: true }
      ]
    };


    // Territories
    this.territoryAssignmentConfigs = {
      gridId: 'territories-grid2',
      countId: 'territoriesCount',
      selectedId: 'territoriesSelected',
      gridName: 'Territory',
      updatedDataSource: [],
      columns: [...columns,
      { field: 'title', headerText: 'Territory', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 60, visible: true },
      { field: 'districtName', headerText: 'District', allowEditing: false, allowFiltering: false, textAlign: 'Left', width: 60, visible: true }
      ]
    };
  }
  ngOnChanges(changes: SimpleChanges): void {
    changes?.['reloadSection'] && changes?.['reloadSection'].currentValue == true && this.getSalesData();
  }
  ngOnInit() {
    this.userId = this.userProfile?.[UPSalesFields.userId];
    this.isCreatingNewUser = (!this.userId && this.source == UPEnums.SourceUser);
    this.initForm();
    this.loadPermissions(true);
    if (!this.isCreatingNewUser) {
      this.salesPreferencesConfig = { apiEndPoint: '', gridId: 'sales-preferences', gridName: 'sales-preferences-grid', userId: this.source == UPEnums.SourceMyProfile ? '' : this.userId, appName: Applications.RimsSales, roleId: this.userProfile?.roleId, hasRoleIdChanged: false };
      this.loadDDLs();
    }
    // handleActions must be called for both new and existing users so that
    // checkValidations (fired on save) is handled and date/form validation errors
    // are correctly registered before any save API calls are made.
    this.handleActions();
  }
  onSelect(args: any) {
    if (args?.itemData?.isDisabled) {
      args.cancel = true;
    }
  }
  loadDDLs() {
    let apis = [
      this.usersService.getWarehouseForSales(this.userProfile?.userId),
      this.usersService.getSalesChannelsByUserId(this.userProfile?.userId)
    ];
    apis = apis.map(api => api.pipe(catchError(error => of(error))));
    forkJoin(apis).subscribe({
      next: (res: any) => {
        this.warehouseDDL = (res[0]?.result as any[]);
        const warehouse = this.salesForm.get(UPSalesFields.warehouse);
        this.warehouseDDL.map(w => {
          if (w.value == warehouse.value) {
            w.isDisabled = false;
            w.text = w.text?.trim().split(' ')[0];
          }
          return w;
        });
        this.channelsDDLData = (res[1]?.result as any[]) ?? [];
        this.refreshChannelRows();
        this.cdRef.markForCheck();
      },
      error: (res: any) => {}
    });
  }

  // The channels grid's rows and ticks (isChecked), without the ticks counting as the user's change.
  refreshChannelRows() {
    this.channelRows.set(SALES_CHANNELS_URL, LocalRowsGridApi.schema([['id', 'int'], ['text', 'varchar'], ['value', 'varchar']]),
      this.channelsDDLData.map(c => ({ id: c.id, text: c.text, value: c.value })));
    this.channelsGrid?.refresh({ keepScroll: true });
    queueMicrotask(() => this.channelsGrid?.setCheckedKeys(this.channelsDDLData.filter(c => c.isChecked).map(c => c.id), { emit: false }));
  }

  // Sales Admin gets every channel (the old header box ticked by code).
  tickAllChannels(): void {
    this.channelsDDLData?.forEach(item => item.isChecked = true);
    this.channelsGrid?.setCheckedKeys(this.channelsDDLData.map(c => c.id), { emit: false });
    this.sectionModified({ modified: true, section: UPEnums.SalesFormData }, 'onHeaderCheckChange');
    this.updateAdditionalServiceDeptsFormValue();
  }

  // A tick or the header box: every channel's isChecked from the grid's ticks, then the form value, as before.
  onChannelsSelected(event: GridRowsSelectedEvent): void {
    const ticked = new Set(event.rows.map(r => r['id']));
    this.channelsDDLData?.forEach(item => item.isChecked = ticked.has(item.id));
    this.sectionModified({ modified: true, section: UPEnums.SalesFormData }, 'onChannelsSelected');
    this.updateAdditionalServiceDeptsFormValue();
  }
  updateAdditionalServiceDeptsFormValue() {
      let depts = [];
      this.channelsDDLData.forEach(sd => sd?.isChecked && depts.push(sd?.value));
      this.salesForm.controls[UPSalesFields.channels].setValue(depts.join(','));
  }
  reloadAssignmentsAgainstRole() {
    const role = this.salesForm.controls?.[UPSalesFields.roleId].value;
    if (role) {
      this.usersService.apiCallStarted('getUserProfileAssignments');
      this.usersService.getUserProfileAssignments(this.source == UPEnums.SourceMyProfile ? '' : this.userId, role).subscribe({
        next: (res: any) => { // missing, remove the following map
          this.usersService.apiCallCompleted('getUserProfileAssignments');
          if(this.isRoleChanged) {
            (res?.result?.regions as any[])?.map(m => m.isChecked = false);
            (res?.result?.districts as any[])?.map(m => m.isChecked = false);
            (res?.result?.territories as any[])?.map(m => m.isChecked = false);
          }
          this.REGIONS_DATA = res?.result?.regions;
          this.DISTRICTS_DATA = res?.result?.districts;
          this.TERRITORY_DATA = res?.result?.territories;
          // ?.map((r: any) => { r.isChecked = false;  return r; }); //testing missing ars
          // this.REGIONS_DATA[1].isReadOnly = true; //testing missing ars
          this.regionAssignmentConfigs.updatedDataSource = this.REGIONS_DATA;
          // ?.map((r: any) => { r.isChecked = false; return r; }); //testing missing ars
          // this.DISTRICTS_DATA[2].isReadOnly = true; //testing missing ars
          // ?.map((r: any) => { r.isChecked = false; return r; }); //testing missing ars
          if (!this.isCreatingNewUser) {
            this.districtAssignmentConfigs.updatedDataSource = this.populateSelectedParentsData("District");
            this.territoryAssignmentConfigs.updatedDataSource = this.populateSelectedParentsData("Territory");
          }
          this.cdRef.markForCheck();
        }, error: (err: any) => {
          this.usersService.apiCallCompleted('getUserProfileAssignments');
        }
      });
    }
  }

  populateSelectedParentsData(child: 'District' | 'Territory'): any[] {
    let filteredData: any[] = [];
    let checkedRegionIds: any[] = [];
    this.REGIONS_DATA.forEach((r: any) => r.isChecked && (checkedRegionIds.push(r.id)));
    checkedRegionIds = Array.from(new Set(checkedRegionIds));
    let checkedDistrictsIds: any[] = [];
    this.DISTRICTS_DATA.forEach((r: any) => r.isChecked && (checkedDistrictsIds.push(r.id)));
    checkedDistrictsIds = Array.from(new Set(checkedDistrictsIds));
    switch (child) {
      case "District":
        checkedRegionIds.forEach((id: any) => {
          filteredData.push(...this.DISTRICTS_DATA.filter((d: any) => d?.regionId == id || d?.regionId == 0));
        });
        // console.log("checkedRegionIds = ",checkedRegionIds)
        // console.log("filteredData = ",filteredData)
        break;
      case "Territory":
        checkedDistrictsIds.forEach((id: any) => {
          filteredData.push(...this.TERRITORY_DATA.filter((t: any) => t?.districtId == id));
        });
        filteredData.push(...this.TERRITORY_DATA.filter((t: any) => t?.districtId == 0));

        break;
    }
    return filteredData;
  }
  onOutputSignal(ac: ISignal) {
    const data = ac?.data.checkedData;
    const id = ac?.data.checkedData.id;
    const type = ac?.data.type;
    const action = ac?.action;

    if (type === 'Region') {
      let filteredDistricts: any[] = [];
      let filteredTerritories: any[] = [];
      switch (action) {
        case "DeselectingAllRegions":
          this.DISTRICTS_DATA?.map((d: any) => { d.regionId != 0 ? d.isChecked = false : null; return d; }); // reset districts selections
          this.TERRITORY_DATA?.map((t: any) => { t.districtId != 0 ? t.isChecked = false : null; return t; }); // reset territories selections
          this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.isChecked = false; return r; });
          this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource.filter((d: any) => d.regionId == 0);
          this.territoryAssignmentConfigs.updatedDataSource = this.TERRITORY_DATA.filter((t: any) => t.districtId == 0);
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'DeselectingAllRegions');
          break;
        case "DeselectingSingleRegion":
          //not just filter but also set isChecked false to the Ds, and Ts which have been hidden due to unchecking the region.
          filteredDistricts = this.districtAssignmentConfigs.updatedDataSource?.filter((d: any) => d.regionId != id || d.regionId == 0);
          filteredTerritories = this.territoryAssignmentConfigs.updatedDataSource?.filter((t: any) => t.regionId != id || t.districtId == 0);

          this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.id == id ? r.isChecked = false : null; return r; })
          this.districtAssignmentConfigs.updatedDataSource = filteredDistricts;
          this.territoryAssignmentConfigs.updatedDataSource = filteredTerritories;
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'DeselectingSingleRegion');
          break;
        case "SelectingAllRegions":
          this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.isChecked = true; return r; })
          this.districtAssignmentConfigs.updatedDataSource = this.DISTRICTS_DATA;
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'SelectingAllRegions');
          break;
        case "SelectingSingleRegion":
          this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.id == id ? r.isChecked = true : null; return r; })
          filteredDistricts = this.DISTRICTS_DATA?.filter((d: any) => d.regionId == id).map((d: any) => { d.isChecked = false; return d; });
          this.districtAssignmentConfigs.updatedDataSource = [...this.districtAssignmentConfigs.updatedDataSource, ...filteredDistricts];
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'SelectingSingleRegion');
          break;
      }
    }
    else if (type === 'District') {
      let filteredTerritories: any[] = [];
      switch (action) {
        case "DeselectingAllDistricts":
          this.territoryAssignmentConfigs.updatedDataSource = this.territoryAssignmentConfigs.updatedDataSource?.map((t: any) => { t.districtId != 0 ? t.isChecked = false : null; return t; }); // reset territories selections
          let filterdIndependentterritories: any[] = this.territoryAssignmentConfigs.updatedDataSource?.filter((it: any) => it.districtId == 0);

          this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.isChecked = false; return d; })
          // this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => {r.isChecked = false; return r;})
          this.territoryAssignmentConfigs.updatedDataSource = filterdIndependentterritories;
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'DeselectingAllDistricts');
          break;
        case "DeselectingSingleDistrict":
          //not just filter but also set isChecked false to the Ts which have been hidden due to unchecking the district.
          filteredTerritories = this.territoryAssignmentConfigs.updatedDataSource?.filter((t: any) => t.districtId != id);
          this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.id == id ? d.isChecked = false : null; return d; });
          this.territoryAssignmentConfigs.updatedDataSource = filteredTerritories;

          // this.setParentCheck(true, data?.regionId);
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'DeselectingSingleDistrict');
          break;
        case "SelectingAllDistricts":
          this.districtAssignmentConfigs.updatedDataSource.forEach((ud: any) => this.populateTerritories(ud));
          // this.territoryAssignmentConfigs.updatedDataSource = this.TERRITORY_DATA;
          this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.isChecked = true; return d; });
          // this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => {r.isChecked = true; return r;})
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'SelectingAllDistricts');
          break;
        case "SelectingSingleDistrict":
          const currentlySelectedDistrictzTerritories = this.TERRITORY_DATA?.filter((t: any) => t.districtId == id).map((t: any) => { t.districtId == id ? t.isChecked = false : null; return t; });
          this.territoryAssignmentConfigs.updatedDataSource = [...this.territoryAssignmentConfigs.updatedDataSource, ...currentlySelectedDistrictzTerritories];
          // filteredTerritories = this.TERRITORY_DATA?.filter((t: any) => t.districtId == id || t.districtId == 0).map((t: any) => {t.districtId == id ? t.isChecked = false : null; return t;});
          // this.territoryAssignmentConfigs.updatedDataSource = filteredTerritories;
          this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.id == id ? d.isChecked = true : null; return d; });

          // this.setParentCheck(true, data?.regionId);
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'SelectingSingleDistrict');
          break;
      }
    }
    else if (type === 'Territory') {
      let filteredTerritories: any[] = [];
      switch (action) {
        case "DeselectingAllTerritories":
          this.territoryAssignmentConfigs.updatedDataSource = this.territoryAssignmentConfigs.updatedDataSource?.map((t: any) => { t.isChecked = false; return t; });
          // this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.isChecked = false; return d; });
          // this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.isChecked = false; return r; });
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'DeselectingAllTerritories');
          break;
        case "DeselectingSingleTerritory":
          this.territoryAssignmentConfigs.updatedDataSource = this.territoryAssignmentConfigs.updatedDataSource?.map((t: any) => { t.id == id ? t.isChecked = false : t; return t; });
          // this.setParentCheck(false, data?.districtId);
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'DeselectingSingleTerritory');
          break;
        case "SelectingAllTerritories":
          this.territoryAssignmentConfigs.updatedDataSource = this.territoryAssignmentConfigs.updatedDataSource?.map((t: any) => { t.isChecked = true; return t; });
          // this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.isChecked = true; return d; });
          // this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.isChecked = true; return r; });
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'SelectingAllTerritories');
          break;
        case "SelectingSingleTerritory":
          this.territoryAssignmentConfigs.updatedDataSource = this.territoryAssignmentConfigs.updatedDataSource?.map((t: any) => { t.id == id ? t.isChecked = true : t; return t; });
          // this.setParentCheck(false, data?.districtId);
          this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'SelectingSingleTerritory');
          break;
      }
    }

  }
  setParentCheck(isParentRegion: boolean, parentId: any) {
    if (isParentRegion) {// isParentRegion, modified a district

      const isAnyDistrictOfCurrentParentRegionChecked = this.districtAssignmentConfigs.updatedDataSource.filter((d: any) => d?.regionId == parentId).some((d: any) => d.isChecked);
      this.regionAssignmentConfigs.updatedDataSource = this.regionAssignmentConfigs.updatedDataSource?.map((r: any) => { r.id == parentId ? r.isChecked = isAnyDistrictOfCurrentParentRegionChecked : null; return r; });


    } else { // isParentDistrict, modified a territory

      const isAnyTerritoryOfCurrentParentDistrictChecked = this.territoryAssignmentConfigs.updatedDataSource.filter((t: any) => t?.districtId == parentId).some((d: any) => d.isChecked);
      this.districtAssignmentConfigs.updatedDataSource = this.districtAssignmentConfigs.updatedDataSource?.map((d: any) => { d.id == parentId ? d.isChecked = isAnyTerritoryOfCurrentParentDistrictChecked : null; return d; });

    }
    this.cdRef.markForCheck();

  }
  populateTerritories(ud: any): void {
    this.territoryAssignmentConfigs.updatedDataSource = [...this.territoryAssignmentConfigs.updatedDataSource, ...Array.from(this.TERRITORY_DATA).filter((t: any) => t.districtId == ud.id)];
    this.cdRef.markForCheck();
  }
  getAddressOfUser(): string {
    let address = '';
    let city = this.salesForm.controls[UPSalesFields.city].value;
    let stateProvince = this.salesForm.controls[UPSalesFields.state].value;
    let zipCode = this.salesForm.controls[UPSalesFields.zipCode].value;
    address = city ? city : '';
    if (stateProvince && stateProvince?.trim() != '') {
      if (city && city?.trim() != '') {
        address += ', ' + stateProvince;
      } else {
        address += stateProvince;
      }
    } else if (city && city?.trim() != '') {
      address += ', ';
    }
    if (zipCode && zipCode?.trim() != '') {
      if (stateProvince && stateProvince?.trim() != '') {
        address += ',';
      }
      address += ' ' + zipCode;
    }
    return address;
  }

  get isEmailAddressValid() {
    let email = this.salesForm.controls[UPSalesFields.email].value;
    return email ? (/^\w+.*@\w+([\.-]?\w+)*(\.\w{2,16})+$/.test(this.salesForm.controls[UPSalesFields.email].value)) : true;
  }
  get isMobileNumberValid() {
    const phoneNumberRegex = /^[\d-()+#]{10,20}$/;
    let mobileNo = this.salesForm.controls[UPSalesFields.mobile].value;
    let check: boolean = mobileNo ? this.isFormSubmitted && mobileNo.replace(/[-()+#]/g, "")?.length > 9 && phoneNumberRegex.test(mobileNo) : true;
    return check;
  }






  modifiedUI: any = {};
  @Output() profileModified = new EventEmitter<profileModificationModel>();
  PERMISSIONS: RolePermissionsModel[] = [];
  @Input() actions: Subject<ISignal> = new Subject();
  action: Subject<ISignal>;
  private destroy$: Subject<any>;
  rolesData: any;
  @Input('userProfile') userProfile: any;
  showAdvancedEmployeesSearchPopup: boolean = false;

setDateToZeroZero(e: any, control: string) {
  if(e?.isInteracted && e?.value) {
    const d = (new Date(new Date(e.value).setUTCHours(12, 0, 0, 0))).toISOString();
    console.log("salesForm ====> "+control+" ====> ", d);
    this.salesForm.get(control).setValue(d);
  }
}

  sectionModified(e: profileModificationModel, from: string) {
    this.cdRef.markForCheck();
    e.section && console.log("UP RIMS SALES: sectionModified => "+ new Date().toISOString(), from, e.section);
    if (e.section && (e.modified != null || e.modified != undefined)) {
      this.modifiedUI[e.section] = e.modified
    } else
      if (e.reloadSection) {
      this.modifiedUI[UPEnums.SalesAssignmentsData] = false;
      this.modifiedUI[UPEnums.SalesFormData] = false;
      this.modifiedUI[UPEnums.SalesPreferencesData] = false;
      this.modifiedUI[UPEnums.SalesAddresses] = false;
    }
    this.profileModified.emit(e);
  }
  getFieldValue(field: string) {
    let val = this.salesForm.controls[field]?.value;
    typeof (val) == 'string' && (val = val.trim());
    return val;
  }
  getSalesData(callback?: () => void) {
    const isCreatingNewUser = (!this.userId && this.source == UPEnums.SourceUser);
    let apis = [
      this.usersService.getRoles(Applications.RimsSales, this.source == UPEnums.SourceMyProfile ? 'myProfile' : 'userProfile').pipe(catchError(error => of(error))),
      this.usersService.getAllEmployeeDetails(Applications.RimsSales).pipe(catchError(error => of(error))),
    ];
    if (isCreatingNewUser) { // Create NEW User
    } else {
      apis.push(this.usersService.getSalesUserById(this.source == UPEnums.SourceMyProfile ? '' : this.userId).pipe(catchError((error: any) => of(error))));
    }
    forkJoin(apis)
      .subscribe({
        next: (responses: any) => {
          this.rolesData = responses[0]?.result;
          this.employeeIdsData = responses[1]?.result ?? [];



          if (!isCreatingNewUser) {
            this.userProfile = responses[2]?.result;
            this.employeeId = responses[2]?.result?.[UPSalesFields.employeeId];
            this.initialRole = responses[2]?.result?.[UPSalesFields.role];
            // !!this.employeeId && this.salesForm.controls[UPSalesFields.employeeId].disable();

            this.initiallyHasNoEmployeeId = (!this.getFieldValue(UPSalesFields.employeeId) && this.source == UPEnums.SourceUser); // ars missing

            // this.employeeId && this.employeeIdsData.push({ employeeId: this.employeeId });
            responses[2]?.result && this.salesForm.patchValue(responses[2]?.result);
            this.sendProfileDataToParent.emit({ section: UPEnums.SalesFormData, data: responses[2]?.result ?? {} });
            const empId = responses[2]?.result['employeeId'];
            const empName = responses[2]?.result['employeeName'];
            
              if (empId && empName && this.employeeIdsData.findIndex(fi => fi.employeeId === empId) == -1) {
             // console.log("Not Found - Sales");
                this.employeeIdsData.push({ employeeId: empId, employeeName: empName, employeeIdDesc: empId + " - " + empName });
              }
            // const empId = responses[2]?.result['employeeId'];
            // const empName = responses[2]?.result['employeeName'];
            // empId && empName && this.salesForm.controls[UPSalesFields.employeeId].setValue(empId + " - " + empName);
            this.usersService.setFormsInUPService('sales', this.salesForm.get(UPSalesFields.isEnabled).value ? this.salesForm : null);
            this.isSectionEnabled = this.source == UPEnums.SourceMyProfile ? true : this.salesForm.controls?.[UPSalesFields.isEnabled].value;
            // this.salesEnableCb && (this.salesEnableCb.checked = (!!this.salesForm.get(UPSalesFields.role).value && !! this.salesForm.get(UPSalesFields.roleId).value && !!this.salesForm.get(UPSalesFields.isEnabled).value));
            this.salesPreferencesConfig.roleId = this.userProfile?.roleId;
            this.salesPreferencesConfig.userId = this.userProfile?.userId;
            // this.action.next({ action: 'roleChangedOrLoaded', data: this.userProfile?.roleId });
          }

          this.isSectionEnabled && this.loadDDLs();
          this.loadPermissions(); // not sure if this is required, therefore commenting this line.
          this.cdRef.markForCheck();
          // this.expandSectionWithDelay();
          callback?.();
        },
        error: (err: any) => {
          callback?.();
          // this.expandSectionWithDelay();
          this.commonService.showNotification('error', err?.error?.message);
        },
      });
  }
  // expandSectionWithDelay() {
  //   setTimeout(() => {
  //     this.expandSalesSection = true;
  //   }, 200);
  // }
  isFormPresent(formName: 'service' | 'sales') {
    return this.usersService.isFormPresent(formName);
  }
  loadPermissions(
    initData: boolean = false,
    category: string = this.source == UPEnums.SourceMyProfile ? UPEnums.MPSalesPermission : UPEnums.UPSalesPermission,
    subCategory: string = this.source == UPEnums.SourceMyProfile ? '' : this.salesForm.controls[UPSalesFields.role].value,
    id: string = this.userId,
    module: string = ''
  ) {
    let api = null;
    this.usersService.apiCallStarted("loadPermissions_Sales");
    if (this.isCreatingNewUser) {
      api = this.usersService.getCreateProfilePermissions(category, subCategory);
    } else {
      api = this.usersService.getEditProfilePermissions(category, subCategory, id);
    }

    api.subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        // The channel boxes lock from these permissions (rowCheckLockedFn): draw them again.
        this.channelsGrid?.refresh({ keepScroll: true });
        this.PERMISSIONS?.map((permission: RolePermissionsModel) => {
          permission.ruleAction = permission.ruleAction.replace('MP_', '').replace('UP_', '');
        });
        // if (!this.getPermission('Sales_canActAsSalesRep')) {
        //   console.log("Sales_canActAsSalesRep PERMISSION NOT FOUND, CURRENTLY USING HARDCODED VISIBILTY PERMISSION")
        //   this.PERMISSIONS.push({
        //     category,
        //     subCategory,
        //     ruleAction: 'Sales_canActAsSalesRep',
        //     visible: this.salesForm.get(UPSalesFields.role)?.value === UserRoles.salesCsa,
        //     enable: true,
        //     readOnly: false,
        //     required: false
        //   });
        // }

        const updateSectionData = () => {
          this.refreshPermissionListItems();
          this.updatePagePermissions().then(() => {
            this.reloadAssignmentsAgainstRole();
            this.reloadPreferencesAgainstRole();
            this.enableDisableAllCheckboxesOfTheSection(!!this.getFieldValue(UPSalesFields.isEnabled));
            this.usersService.apiCallCompleted("loadPermissions_Sales");
            this.cdRef.markForCheck();  
          });
        };
        
        if (this.getPermission('Sales_Section')?.enable) {
          initData ? this.getSalesData(() => {
            updateSectionData();
          }) : updateSectionData();
        } else {
          this.salesForm.get(UPSalesFields.isEnabled).disable();
          this.usersService.apiCallCompleted("loadPermissions_Sales");
        }

      },
      error: (err: any) => {
        this.PERMISSIONS = [];
        this.usersService.apiCallCompleted("loadPermissions_Sales");
      }
    });
  }
  reloadPreferencesAgainstRole() {
    const roleId = this.salesForm.controls?.[UPSalesFields.roleId].value;
    if (roleId) {
      this.action.next({ action: 'roleChangedOrLoaded', data: roleId });
    }
  }
  updatePagePermissions(): Promise<boolean> {
    return new Promise((resolve) => {
      [
        { control: UPSalesFields.isEnabled, rule: 'Sales_enable' },
        // { control: UPSalesFields.role, rule: 'Sales_rolesDropdown' },
        { control: UPSalesFields.startDate, rule: 'Sales_startDate' },
        { control: UPSalesFields.endDate, rule: 'Sales_endDate' },
        { control: UPSalesFields.employeeId, rule: 'Sales_employeeId' },
        { control: UPSalesFields.mobile, rule: 'Sales_mobile' },
        { control: UPSalesFields.email, rule: 'Sales_email' },
        { control: UPSalesFields.warehouse, rule: 'Sales_warehouse' },
        { control: UPSalesFields.isApprover, rule: 'Sales_isApproved' },
        { control: UPSalesFields.canActAsSalesRep, rule: 'Sales_canActAsSalesRep' },
        { control: UPSalesFields.channels, rule: 'Sales_channels' },
      ]
        .forEach((e) => { this.updateUIElement(e.control, e.rule) });
      this.refreshPermissionListItems();
      setTimeout(() => {
        resolve(true);
      }, 200);


    });
  }
  updateUIElement(control: string, rule: string) {
    if (control === UPSalesFields.isApprover || control === UPSalesFields.canActAsSalesRep) {
      const checkboxControl = this.salesForm.controls[control];
      const permission = this.getPermission(rule);
      if (!permission) {
        checkboxControl?.disable();
        checkboxControl?.removeValidators(Validators.requiredTrue);
      } else {
        this.isCheckboxEnabled(rule) ? checkboxControl?.enable() : checkboxControl?.disable();
        permission.required && permission.visible
          ? checkboxControl?.addValidators(Validators.requiredTrue)
          : checkboxControl?.removeValidators(Validators.requiredTrue);
      }
      checkboxControl?.updateValueAndValidity();
      return;
    }

    setTimeout(() => {
      
    const RULE = this.getPermission(rule);
    if (!RULE) {
      const  r = JSON.parse(JSON.stringify(this.getPermission('Sales_enable')));
   console.log(`Sales->This permission is missing in DB: ruleAction: ${rule} & category: ${r?.category} & subCategory: ${r?.subCategory}`);
    } else {
      if (rule == 'Sales_enable') {
        const isDisabled = (!RULE?.enable || !!RULE?.readOnly || !this.userId || this.usersService.getUserGlobbayDisabled());
        isDisabled ?
          this.salesForm.controls[control].disable() :
          this.salesForm.controls[control].enable();
        (!!RULE?.required && !!RULE?.visible && !!this.userId) ?
          this.salesForm.controls[control].addValidators(Validators.required) :
          this.salesForm.controls[control].removeValidators(Validators.required);
      } else {
        (!RULE?.enable || !!RULE?.readOnly || !this.isSectionEnabled) ?
          this.salesForm.controls[control].disable() :
          this.salesForm.controls[control].enable();
        (!!RULE?.required && !!RULE?.visible) ?
          this.salesForm.controls[control].addValidators(Validators.required) :
          this.salesForm.controls[control].removeValidators(Validators.required);
      }
      this.salesForm.controls[control].updateValueAndValidity();
    }

    }, 1500);


    // const RULE = this.getPermission(rule);
    // (!RULE?.enable || !!RULE?.readOnly) ?
    //   this.salesForm.controls[control].disable() :
    //   this.salesForm.controls[control].enable();
    // (!!RULE?.required && !!RULE?.visible) ?
    //   this.salesForm.controls[control].addValidators(Validators.required) :
    //   this.salesForm.controls[control].removeValidators(Validators.required);
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  isCheckboxEnabled(ruleAction: string): boolean {
    const permission = this.getPermission(ruleAction);
    return this.isSectionEnabled && (permission?.enable === true || permission?.readOnly === false);
  }
  isCheckboxVisible(ruleAction: string): boolean {
    const permission = this.getPermission(ruleAction);
    return this.isSectionEnabled && (permission?.visible === true || permission?.readOnly === false);
  }
  refreshPermissionListItems(resetIvisibleCheckboxes?: boolean): void {
    const permissions = [
      { id: UPSalesFields.isApprover, text: 'Sales Order Approver', tooltipText: "Sales Order Approver", ruleAction: 'Sales_isApproved' },
      { id: UPSalesFields.canActAsSalesRep, text: 'Act as Sales Rep', tooltipText: "This CSA can create Opportunities.", ruleAction: 'Sales_canActAsSalesRep' }
    ];
    this.permissionListItems = permissions
      .filter(item => this.getPermission(item.ruleAction)?.visible)
      .map(item => ({
        id: item.id,
        text: item.text,
        tooltipText: item.tooltipText,
        isChecked: !!this.salesForm.get(item.id)?.value,
        enabled: this.isCheckboxEnabled(item.ruleAction)
      }));
      resetIvisibleCheckboxes && this.resetChecboxValueIfCheckboxIsNotVisible(permissions)
  }
  resetChecboxValueIfCheckboxIsNotVisible(permissions: { id: UPSalesFields; ruleAction: string; }[]) {
    permissions.forEach(p => {
      const isNotVisible = this.getPermission(p.ruleAction)?.visible !== true;
      isNotVisible && (this.salesForm.get(p.id)?.setValue(false));
    })
  }
  onPermissionListSelect(args: SelectEventArgs): void {
    const selectedItem = args?.data;
    if (!selectedItem || Array.isArray(selectedItem) || typeof selectedItem !== 'object' ||
        typeof selectedItem['id'] !== 'string' || typeof args?.isChecked !== 'boolean') {
      return;
    }

    const permission = this.permissionListItems.find(item => item.id === selectedItem['id']);
    if (!permission?.enabled) {
      return;
    }

    this.salesForm.get(selectedItem['id'])?.setValue(args.isChecked);
    this.refreshPermissionListItems();
    this.sectionModified(
      { modified: true, section: UPEnums.SalesFormData },
      `listview-${selectedItem['id']}Changed`
    );
    this.markedForPersistenceClearance = true;
    this.cdRef.markForCheck();
  }
  clearPersistence() {
    if (this.getPermission('Sales_resetPreferencesButton')?.enable && this.isSectionEnabled) {
      this.commonService.showConfirmation('Are you sure to clear persistence?')
        .then(res => {
          if (res?.isConfirmed) {
            this.usersService.apiCallStarted("clearPersistence");
            this.usersService.clearPersistence(this.salesForm.controls[UPSalesFields.userId]?.value, Applications.RimsSales)
              .subscribe({
                next: (res: any) => {
                  this.usersService.apiCallCompleted("clearPersistence");
                  this.commonService.showNotification('info', res.message);
                },
                error: (err: any) => {
                  this.commonService.showNotification('error', err?.error?.message);
                  this.usersService.apiCallCompleted("clearPersistence");
                },
              });
          }
        });
    }
  }

  resetFieldValue(c: UPSalesFields): void {
    // check if the user is created with employeeId, do not reset the employeeId then
    (!this.employeeId || c != UPSalesFields.employeeId) && this.salesForm.get(c)?.reset("");
    this.salesForm.markAsPristine();
  }
  onRolesChange(e: any) {
    const roleId = e?.itemData?.displayOrder;
    const role = e?.itemData?.role;
    if (e?.isInteracted) {
      const previousRole = this.salesForm.controls[UPSalesFields.role].value;
      const previousRoleId = this.salesForm.controls[UPSalesFields.roleId].value;
      const removeAssignments = this.initialRole
        && this.regionAssignmentConfigs.updatedDataSource?.filter(f => f.isChecked)?.length
        && [UserRoles.salesRep, UserRoles.salesDistricMgr, UserRoles.salesRegionalMgr].includes(previousRole)
        && [UserRoles.salesRep, UserRoles.salesDistricMgr, UserRoles.salesRegionalMgr].includes(role);
        if(removeAssignments) {
          this.commonService.showConfirmation(
            'Changing the user’s role will remove all existing Region, District, and Territory assignments (if any). Do you want to continue?',
            'Yes', 'No', 'Sales'
          ).then((res: any) => {
            if (res.isConfirmed) {
              this.removeAssignmentsForRoleChange();
              // check if previously there is no role saved Against the user.
              this.isRoleChanged = !!previousRole;
              
              this.salesPreferencesConfig.hasRoleIdChanged = this.isRoleChanged;
              
              
              if (roleId) {
                this.salesForm.controls?.[UPSalesFields.roleId]?.setValue(roleId);
                this.salesForm.controls?.[UPSalesFields.role]?.setValue(role);
              }
              this.sectionModified({ modified: true, section: UPEnums.SalesFormData, updatedPermissiosParameters: { category: this.source == UPEnums.SourceMyProfile ? UPEnums.MPSalesPermission : UPEnums.UPSalesPermission, id: this.source == UPEnums.SourceMyProfile ? '' : this.userId, subCategory: role } }, 'onRolesChange');
            } else {
              this.salesForm.controls?.[UPSalesFields.role]?.setValue(previousRole);
              this.salesForm.controls?.[UPSalesFields.roleId]?.setValue(previousRoleId);
            }
          });
        } else {
        // check if previously there is no role saved Against the user.
        this.isRoleChanged = !!previousRole;
        
        this.salesPreferencesConfig.hasRoleIdChanged = this.isRoleChanged;
        
        
        if (roleId) {
          this.salesForm.controls?.[UPSalesFields.roleId]?.setValue(roleId);
          this.salesForm.controls?.[UPSalesFields.role]?.setValue(role);
        }
        this.sectionModified({ modified: true, section: UPEnums.SalesFormData, updatedPermissiosParameters: { category: this.source == UPEnums.SourceMyProfile ? UPEnums.MPSalesPermission : UPEnums.UPSalesPermission, id: this.source == UPEnums.SourceMyProfile ? '' : this.userId, subCategory: role } }, 'onRolesChange');
      }

    }
    if(role == UserRoles.salesAdmin) {
      this.tickAllChannels();
    }
  }
  resetTheForm() {
    [UPSalesFields.email, UPSalesFields.mobile, UPSalesFields.endDate, UPSalesFields.startDate]
      .forEach((control: string) => this.salesForm.controls[control]?.setValue(''));
  }

  isUserGlobalDisabled() {
    return this.usersService.getUserGlobbayDisabled();
  }
  handleActions() {
    if (this.actions != null) {
      this.actions
        .pipe(takeUntil(this.destroy$))
        .subscribe((ac: ISignal) => {
       // console.log(new Date().toISOString(), ac?.action);
          this.cdRef.markForCheck();
          let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
          if (ac?.action === 'reloadPermissions' && (ac?.data.category == UPEnums.UPSalesPermission || ac?.data.category == UPEnums.MPSalesPermission)) {
            
            this.loadPermissions(false, ac?.data?.category, ac?.data?.subCategory, ac?.data?.id, ac?.data?.module);
          } else if (ac?.action === 'checkValidations') {
            
            let hasSelectedTerritories = !!this.territoryAssignmentConfigs.updatedDataSource.filter((t: any) =>  t?.isChecked)?.length;
            let hasSelectedDistricts = !!this.districtAssignmentConfigs.updatedDataSource.filter((d: any) =>  d?.isChecked)?.length;
            let hasSelectedRegions = !!this.regionAssignmentConfigs.updatedDataSource.filter((r: any) =>  r?.isChecked)?.length;
            const role = this.salesForm.controls?.[UPSalesFields.role].value;        

            if (this.markAddressToBeCopiedOverToGeneral) {
              this.copyDataToGeneral();
              this.markAddressToBeCopiedOverToGeneral = false;
            }
            this.cdRef.markForCheck();
            this.commonService.printInvalidControls(this.salesForm, 'up-sales.ts');

            if (!this.isSectionEnabled) {
              // Section disabled — clear any stale invalid entries and exit.
              this.usersService.setInvalidData(false, UPEnums.SalesFormData);
            } else if(
              (this.getPermission('Sales_territories')?.visible && role === UserRoles.salesRep && hasSelectedRegions && !hasSelectedTerritories) ||
              (this.getPermission('Sales_districts')?.visible && role === UserRoles.salesDistricMgr && hasSelectedRegions && !hasSelectedDistricts)
            ) {
              this.commonService.showNotification("info", "Please select all required hierarchy levels before saving. If a Region is selected, you must also select the corresponding District and Territory.");
              this.usersService.setInvalidData(true, UPEnums.SalesAssignmentsData);
            } else if (this.usersService.invalidDataSections?.includes(UPEnums.SalesFormData)) {
              // Dates were already flagged invalid by the General handler's
              // areDatesInvalid() which runs before this handler. Stop here so
              // we don't accidentally clear that flag below.
              return;
            } else if (hasUnsavedChanges) {
              // Section enabled + has pending changes: validate form fields.
              this.isFormSubmitted = true;
              if (this.salesForm.invalid || !this.isMobileNumberValid || !this.isEmailAddressValid) {
                this.usersService.setInvalidData(true, UPEnums.SalesFormData);
                this.commonService.showNotification('info', 'RIMS Sales: Please enter valid data!');
              } else if (this.isRoleChanged) {
                this.usersService.setInvalidData(true, UPEnums.SalesFormData);
                this.commonService.showConfirmation(
                  `'You are changing the role for this user, are you sure to do that?`,
                  'Yes', 'No', 'Sales'
                ).then((res: any) => {
                  if (res.isConfirmed) {
                    this.usersService.setInvalidData(false, UPEnums.SalesFormData);
                    this.usersService.hitSaveAll.next(true);
                  }
                });
              } else {
                this.usersService.setInvalidData(false, UPEnums.SalesFormData);
              }
            } else {
              // Section enabled but no unsaved changes — clear any stale errors.
              this.usersService.setInvalidData(false, UPEnums.SalesFormData);
            }
          } else if (ac?.action === 'saveAll' && hasUnsavedChanges) {
              if (UserProfileService.invalidDataCount <= 0) {
                this.saveProfile();
              }
          }
        });
    }
  }
  removeAssignmentsForRoleChange() {
    this.regionAssignmentConfigs.updatedDataSource?.forEach(m => m.isChecked = false);
    this.regionAssignmentConfigs.updatedDataSource = [...this.regionAssignmentConfigs.updatedDataSource];
    this.districtAssignmentConfigs.updatedDataSource = [];
    this.territoryAssignmentConfigs.updatedDataSource = [];
    this.sectionModified({ modified: true, section: UPEnums.SalesAssignmentsData }, 'resetAssignmentsForRoleChange');
  }
getMaxED() {
    const sdsales = this.salesForm.get(UPSalesFields.startDate).value || '';
    let maxDate = null;
    // (this.usersService.getMinEndDate() && this.usersService.getMinEndDate() > sdsales) ? (maxDate = this.usersService.getMinEndDate()) : (maxDate = sdsales);
    maxDate = sdsales;
    return maxDate;
  }
  checkDatesFor(dateFor: 'SD' | 'ED') {
    const datesValidations = this.usersService.checkDatesFor('sales', dateFor);
    !this.isSectionEnabled && (datesValidations.isInvalid = false);
    return datesValidations;
  }
  copyDataToGeneral() {
    // this.commonService.showConfirmation("Do you want to copy the mobile phone, email and address to the general section.").then((res: any) => {
    //   if (res.isConfirmed) {
            let addresses = this.usersService.getGeneralAddressCodes();
            const isAddressAlreadyPresent = this.newAddress?.addressCode && addresses.some(generalAddress => this.newAddress?.addressCode && (generalAddress?.addressCode == this.newAddress?.addressCode));
        this.usersService.copyDataToGeneral.next({
          // [UPGeneralFields.primaryEmail]: this.getFieldValue(UPSalesFields.email),
          // [UPGeneralFields.primaryMobile]: this.getFieldValue(UPSalesFields.mobile),
          "newAddress": !isAddressAlreadyPresent && this.newAddress
        });
        this.newAddress = null;
    //   }
    // })
  }
  saveProfile() {
    this.salesForm.get(UPSalesFields.channels).setValue(this.channelsDDLData?.filter(f => f.isChecked)?.map(m => m.value)?.join());
    if (this.modifiedUI[UPEnums.SalesFormData] === true && !this.isSalesProfileSaveInProgress) {
      this.usersService.apiCallStarted("saveProfile");
      const resetWarehouseField = !this.getPermission('Sales_warehouse')?.visible || !this.salesForm.get(UPSalesFields.warehouse).value;
      resetWarehouseField && this.salesForm.get(UPSalesFields.warehouse).setValue('');
      const empId = this.salesForm.get(UPSalesFields.employeeId); // avoid null value in payload
      !empId.value ? empId.setValue('') : empId.setValue(empId.value?.split(' ')?.[0]); // avoid null value in payload
      this.refreshPermissionListItems(true);
      let payload = {
        ...this.salesForm.getRawValue(),
        userId: this.source == UPEnums.SourceMyProfile ? this.commonService.getUserId() : this.userId
      }
      
      // payload[UPSalesFields.startDate] = payload[UPSalesFields.startDate]?.toISOString()?.split('Z')[0];
      // payload[UPSalesFields.endDate] = payload[UPSalesFields.endDate]?.toISOString()?.split('Z')[0];
      payload.startDate = payload?.startDate != null && typeof payload.startDate == 'object' ? payload.startDate?.toISOString()?.split('Z')[0] : payload?.startDate;
      payload.endDate = payload?.endDate != null && typeof payload.endDate == 'object' ? payload.endDate?.toISOString()?.split('Z')[0] : payload?.endDate;
      this.isSalesProfileSaveInProgress = true;
      this.usersService.saveSalesSection(payload).pipe(
        finalize(() => this.isSalesProfileSaveInProgress = false) // handles multiple apis calling on one time save button's click
      ).subscribe({
        next: (res: any) => {          
          this.employeeId = res?.result?.[UPSalesFields.employeeId];
          this.initialRole = res?.result?.[UPSalesFields.role];
          this.salesForm.patchValue(res?.result);
          this.sendProfileDataToParent.emit({ section: UPEnums.SalesFormData, data: res?.result ?? {} });
          // this.salesForm.controls[UPSalesFields.employeeId].setValue(this.employeeId+' - '+res?.result?.employeeName);
          
          this.usersService.setFormsInUPService('sales', this.salesForm.get(UPSalesFields.isEnabled).value ? this.salesForm : null);
          this.sectionModified({ modified: false, section: UPEnums.SalesFormData, updatedPermissiosParameters: { category: this.source == UPEnums.SourceMyProfile ? UPEnums.MPSalesPermission : UPEnums.UPSalesPermission, id: this.source == UPEnums.SourceMyProfile ? '' : this.userId } }, 'saveProfile');
          this.modifiedUI[UPEnums.SalesFormData] = false;
          // this.commonService.showNotification('info', res.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: true,
                          message:  res?.message
                        });
          this.isFormSubmitted = false;
          this.usersService.apiCallCompleted("saveProfile");
          this.isRoleChanged = false;
          this.loadDDLs();
          this.markedForPersistenceClearance && this.clearUserPersistenceForRIMSSales();
        },
        error: (err: any) => {
          this.modifiedUI[UPEnums.SalesFormData] = true;
          // this.commonService.showNotification('error', err?.error?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: false,
                          message:  err?.error?.message
                        });
          this.usersService.apiCallCompleted("saveProfile");
        },
      });
    }

    if (this.modifiedUI[UPEnums.SalesPreferencesData] === true) {
      this.action.next({ action: 'saveAll', data: null });
    }
    if (this.modifiedUI[UPEnums.SalesAssignmentsData] === true) {
      let regions: any[] = [];
      this.getPermission('Sales_regions').visible && this.regionAssignmentConfigs.updatedDataSource.forEach((r: any) => { r?.isChecked ? regions.push(r.id) : null });
      let districts: any[] = [];
      this.getPermission('Sales_districts').visible && this.districtAssignmentConfigs.updatedDataSource.forEach((d: any) => { d?.isChecked ? districts.push(d.id) : null });
      let territories: any[] = [];
      this.getPermission('Sales_territories').visible && this.territoryAssignmentConfigs.updatedDataSource.forEach((t: any) => { t?.isChecked ? territories.push(t.id) : null });
      this.usersService.apiCallStarted("saveAssignments");
      setTimeout(() => {
        
      this.usersService.saveUserProfileAssignments({
        userId: this.userId,
        regionIds: regions, //[1,2]
        districtIds: districts, //[207,208]
        territoryIds: territories
      }).subscribe({
        next: (res: any) => {
          this.usersService.apiCallCompleted("saveAssignments");
          // this.commonService.showNotification('info', res?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: true,
                          message:  res?.message
                        });
          this.sectionModified({ modified: false, section: UPEnums.SalesAssignmentsData }, 'saveAssignments');
        },
        error: (err) => {
          this.usersService.apiCallCompleted("saveAssignments");
          // this.commonService.showNotification('error', err?.error?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: false,
                          message:  err?.error?.message
                        });
        }
      });
      }, 500);
    }
  }
  removeTrailingSpaces(control: any): void {
    this.salesForm.get(control)?.setValue(this.salesForm.get(control)?.value?.trim());
  }

   initForm(data?: any) {
    this.salesForm.addControl(UPSalesFields.userId, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.isEnabled, new FormControl(false));
    this.salesForm.addControl(UPSalesFields.role, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.roleId, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.startDate, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.endDate, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.employeeId, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.mobile, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.email, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.warehouse, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.isApprover, new FormControl(false));
    this.salesForm.addControl(UPSalesFields.canActAsSalesRep, new FormControl(false));
    this.salesForm.addControl(UPSalesFields.channels, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.appName, new FormControl(Applications.RimsSales));

    this.salesForm.addControl(UPSalesFields.name, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.addressCode, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.address, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.city, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.zipCode, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.state, new FormControl(''));
    this.salesForm.addControl(UPSalesFields.country, new FormControl(''));

  }
  isEmpty(strValue: string): boolean {
    return typeof (strValue) === 'string' && strValue?.trim() === '';
  }
  onEmployeeIdChange(isInteracted: boolean, data: any) {
    if (isInteracted) {
      if (data) {
        this.employeeId = data?.[UPSalesFields.employeeId];
        data = Object.fromEntries(
          Object.entries(data).map(([key, value]) => [
            key,
            typeof value === 'string' ? value?.trim() : value
          ])
        );
        data[UPSalesFields.mobile] = data?.telephone;
        delete data[UPSalesFields.role];
        delete data[UPSalesFields.roleId];
        delete data[UPSalesFields.warehouse];
        data && this.salesForm.patchValue(data);
        if (!this.isEmpty(data[UPSalesFields.addressCode])) {
          this.newAddress = {
            "addressCode": data[UPSalesFields.addressCode],
            "name": data[UPSalesFields.name],
            "address": data[UPSalesFields.address],
            "address2": data[UPSalesFields.address2],
            "houseNumber": data[UPSalesFields.houseNumber],
            "postBoxNumber": data[UPSalesFields.postBoxNumber],
            "city": data[UPSalesFields.city],
            "stateProvince": data[UPSalesFields.state] ?? data["stateProvince"],
            "country": data[UPSalesFields.country],
            "countryId": data[UPGeneralFields.countryId],
            "zipCode": data[UPSalesFields.zipCode],
            "telephone": data[UPSalesFields.mobile],
            "isDefault": false,
            "isLNPreferred": false,
            "isDeleted": false
          };
        }
        let addresses = this.usersService.getGeneralAddressCodes();
        const isAddressAlreadyPresent = addresses.some(generalAddress => generalAddress?.addressCode == this.newAddress?.addressCode);
        if (!!this.getFieldValue(UPSalesFields.email) || !!this.getFieldValue(UPSalesFields.mobile) || !isAddressAlreadyPresent) {
          // this.copyDataToGeneral();
          this.markAddressToBeCopiedOverToGeneral = true;
        }
      } else {
        this.employeeId = '';
        this.resetControl([
          UPSalesFields.employeeId,
          UPSalesFields.email,
          UPSalesFields.name,
          UPSalesFields.addressCode,
          UPSalesFields.address,
          UPSalesFields.city,
          UPSalesFields.state,
          UPSalesFields.country,
          UPSalesFields.zipCode
        ]);
      }
      this.sectionModified({modified: true, section: UPEnums.SalesFormData}, "onEmployeeIdChange");
    }
  }
  resetControl(controls: UPSalesFields[], value: any = ""): void {
    controls.forEach(f => {
      this.salesForm.controls[f].setValue(value);
      this.salesForm.controls[f].updateValueAndValidity();
    })
  }

  onEnableSectionCheckboxChange(e: any) {
    if (this.salesEnableCb?.checked) {
      this.enableDisableApp(true);
    } else {
      let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
      if(hasUnsavedChanges) {
        this.commonService.showConfirmation("Any unsaved data will be lost, are you sure to disable this user on sales application?")
          .then((res: any) => {
            if (res?.isConfirmed) {
              this.enableDisableApp(false);
            } else {
              this.salesEnableCb.checked = true;
            }
          });
      } else {
        this.commonService.showConfirmation("Are you sure to disable this user on sales application?")
          .then((res: any) => {
            if (res?.isConfirmed) {
              this.enableDisableApp(false);
            } else {
              this.salesEnableCb.checked = true;
            }
          });
      }
    }
  }
  enableDisableApp(toggle: boolean) {
    this.usersService.apiCallStarted('SalesEnableCb');
    this.usersService.setFormsInUPService('sales', toggle ? this.salesForm : null);
    this.usersService.enableDisableApplication(this.userId, Applications.RimsSales, toggle).subscribe({
      next: (res: any) => {
        this.usersService.apiCallCompleted('SalesEnableCb');
        if ((res?.message as string)?.includes('assigned')) {
          this.commonService.showNotification("warning", res?.message);
          this.salesEnableCb && (this.salesEnableCb.checked = !toggle);
        } else {
        let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
        // reload if disabling and has unsaved changes, will reset UI because changes were not saved.
        this.sectionModified({ reloadSection: 'sales' }, 'disableSalesSection but nothing modified');
        // reload if enabling, we want the latest details of the section to be loaded when enabling the section.
        // toggle && this.sectionModified({ reloadSection: 'sales' },'enableSalesSection but nothing modified');
        this.isSectionEnabled = toggle;
        this.enableDisableAllCheckboxesOfTheSection(toggle);
      }
      },
      error: (err: any) => {
        this.usersService.apiCallCompleted('SalesEnableCb');
        this.isSectionEnabled = !toggle;
        this.salesEnableCb && (this.salesEnableCb.checked = !toggle);
        this.enableDisableAllCheckboxesOfTheSection(!toggle);
        this.commonService.showNotification("error", err?.error?.message);
      }
    });
  }
  // The section's checkboxes: Approver here; the Channels and Assignments grids lock their boxes from isSectionEnabled
  // (rowCheckLockedFn), so they only need to draw again. Before, this reached into every Syncfusion grid checkbox on the page.
  enableDisableAllCheckboxesOfTheSection(enable: boolean) {
    const approverControl = this.salesForm.get(UPSalesFields.isApprover);
    const salesRepControl = this.salesForm.get(UPSalesFields.canActAsSalesRep);
    enable && this.isCheckboxEnabled('Sales_isApproved') ? approverControl?.enable() : approverControl?.disable();
    enable && this.isCheckboxEnabled('Sales_canActAsSalesRep') ? salesRepControl?.enable() : salesRepControl?.disable();
    this.refreshPermissionListItems();
    this.channelsGrid?.refresh({ keepScroll: true });
  }
  clearUserPersistenceForRIMSSales() {
    this.commonService.clearUserPersistenceForRIMSSales();
    this.markedForPersistenceClearance = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
